import React, { PureComponent } from 'react';
import { Row, Col, Radio } from 'antd';
import styles from './AccountProvider.less';
import AccountDetails from './AccountDetails';
import FadedCard from '../FadedCards';

class AccountProvider extends PureComponent {
  onFormValuesChange = (field, value) => {
    this.props.providerCallback('accountProvider', {
      [field]: value,
    });
  };
  render() {
    const { value, accountName, regions, protectionLevel } = this.props.data;
    const { xrayEnabledCloudProviders, allCloudAccountsList } = this.props;

    const cardData = [
      {
        title: 'ADVANCED',
        description: `Complete Cloudnosys security suite, including <br/><b>CloudEye:</b> Misconfigurations Detection
        <br/><b>Cloudxray:</b> Malware & OS Vulnerabilities
        <br/><b>EagleEye:</b> Real-time Threat Detection`,
        subDescription: `Setup time 10-15 mins`,
        key: 'advanced',
      },
      {
        title: 'BASIC (CloudEye)',
        description: `Catalog your cloud resources and detect misconfiguration level violations<br/>(Cloud security posture management, CSPM)`,
        subDescription: `Setup time > 5 mins`,
        key: 'basic',
      },
    ];

    return (
      <div>
        <h5 style={{ marginBottom: '25px', color: 'black' }}>Select your Cloud Account Provider</h5>
        <Row gutter={8} className={styles.row}>
          <Col span={4}>
            <div
              style={{
                height: 140,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: value === 'AWS' ? '#0090FF1A' : '',
                border: value === 'AWS' ? '1px solid #3AA0FF' : '1px solid #d9d9d9',
                borderRadius: '0.5rem',
                padding: '0.5rem',
                cursor: 'pointer',
              }}
              onClick={() => {
                this.props.providerCallback('accountProvider', {
                  value: 'AWS',
                  protectionLevel: xrayEnabledCloudProviders.includes('aws') ? 'advanced' : 'basic',
                });
              }}
            >
              <img
                style={{
                  height: 70,
                  width: 70,
                  objectFit: 'contain',
                }}
                src="/awslist.png"
                alt="aws"
              />
            </div>
          </Col>

          <Col span={4}>
            <div
              style={{
                height: 140,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: value === 'AZURE' ? '#0090FF1A' : '',
                border: value === 'AZURE' ? '1px solid #3AA0FF' : '1px solid #d9d9d9',
                borderRadius: '0.5rem',
                padding: '0.5rem',
                cursor: 'pointer',
              }}
              onClick={() => {
                this.props.providerCallback('accountProvider', {
                  value: 'AZURE',
                  protectionLevel: xrayEnabledCloudProviders.includes('azure')
                    ? 'advanced'
                    : 'basic',
                });
              }}
            >
              <img
                style={{
                  height: 60,
                  width: 120,
                  objectFit: 'contain',
                }}
                src="/azure2.png"
                alt="azure2"
              />
            </div>
          </Col>
          <Col span={4}>
            <div
              style={{
                height: 140,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: value === 'GCP' ? '#0090FF1A' : '',
                border: value === 'GCP' ? '1px solid #3AA0FF' : '1px solid #d9d9d9',
                borderRadius: '0.5rem',
                padding: '0.5rem',
                cursor: 'pointer',
              }}
              onClick={() => {
                this.props.providerCallback('accountProvider', {
                  value: 'GCP',
                  protectionLevel: xrayEnabledCloudProviders.includes('gcp') ? 'advanced' : 'basic',
                });
              }}
            >
              <img
                style={{
                  height: 80,
                  width: 100,
                  objectFit: 'contain',
                }}
                src="/gcpProvider.png"
                alt="gcp"
              />
            </div>
          </Col>
        </Row>
        {value.length > 0 && (
          <>
            <AccountDetails
              allCloudAccountsList={allCloudAccountsList}
              onFormValuesChange={this.onFormValuesChange}
              selectedCloud={value}
              accountName={accountName}
              regions={regions}
            />
            <h5 style={{ marginBottom: '25px', color: 'black' }}>Select Protection Level</h5>
            <div style={{ display: 'flex', alignItems: 'stretch', gap: '1rem' }}>
              {cardData.map(data => (
                <FadedCard
                  xrayEnabledCloudProviders={xrayEnabledCloudProviders}
                  data={data}
                  value={value}
                  selectedProtectionLevel={protectionLevel}
                  onChangeFunction={this.onFormValuesChange}
                />
              ))}
            </div>
          </>
        )}
      </div>
    );
  }
}

export default AccountProvider;
